import Head from 'next/head';

interface PageHeadProps {
  title: string
}

const PageHead = ({ title }: PageHeadProps)=> (
  <Head>
    <title>{`Classwallet | Vendor Portal | ${title}`}</title>
    <link rel="shortcut icon" href="/images/cw-logo.ico" />
  </Head>
);

export default PageHead;
